export const Input = (props) => {
    return (
        <input
            {...props}
        />
    );
}